import { QRCode } from "@progress/kendo-react-barcodes";

interface QrPaymentSlipMockupProps {
    iban: string;
    referenceNumber: string;
    cdtrName: string;
    cdtrStreet: string;
    cdtrHouseNumber: string;
    cdtrPostalCode: string;
    cdtrCity: string;
    cdtrCountry: string;
}

const fontMultiplier = 0.3527777778;

export const QrPaymentSlipMockup = ({
    iban,
    referenceNumber,
    cdtrName,
    cdtrStreet,
    cdtrHouseNumber,
    cdtrPostalCode,
    cdtrCity,
}: QrPaymentSlipMockupProps) => {
    const displayIban = iban || 'CH00 0000 0000 0000 0000 0';
    const displayName = cdtrName || 'Name des Kontoinhabers';
    const displayStreet = cdtrStreet || 'Musterstrasse';
    const displayHouseNumber = cdtrHouseNumber || '123';
    const displayPostalCode = cdtrPostalCode || '8000';
    const displayCity = cdtrCity || 'Zürich';
    const displayReference = referenceNumber || '00 00000 00000 00000 00000 00000';

    return (
        <div className="bg-white rounded-lg shadow-lg overflow-hidden" style={{ width: 560, height: 280 }}>
            <div style={{
                transform: 'scale(0.7)',
                transformOrigin: 'top left',
                width: 800,
                marginLeft: 0,
            }}>
                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        width: "210mm",
                        height: "105mm",
                        fontFamily: "sans-serif",
                    }}
                >
                    {/* Left section - Empfangsschein */}
                    <div
                        style={{
                            width: "62mm",
                            borderRight: "0.5px solid black",
                            padding: "5mm",
                        }}
                    >
                        <div style={{ fontSize: 11 * fontMultiplier + "mm", fontWeight: "bold", marginBottom: "7mm" }}>
                            Empfangsschein
                        </div>
                        <div style={{ marginBottom: 9 * fontMultiplier + "mm" }}>
                            <div style={{ fontSize: 6 * fontMultiplier + "mm", fontWeight: "bold" }}>Konto / Zahlbar an</div>
                            <div style={{ fontSize: 8 * fontMultiplier + "mm" }}>
                                <p>{displayIban}</p>
                                <p>{displayName}</p>
                                <p>{displayStreet} {displayHouseNumber}</p>
                                <p>{displayPostalCode} {displayCity}</p>
                            </div>
                        </div>
                        <div style={{ marginBottom: 9 * fontMultiplier + "mm" }}>
                            <div style={{ fontSize: 6 * fontMultiplier + "mm", fontWeight: "bold" }}>Referenz</div>
                            <div style={{ fontSize: 8 * fontMultiplier + "mm" }}>{displayReference}</div>
                        </div>
                        <div style={{ marginBottom: 9 * fontMultiplier + "mm" }}>
                            <div style={{ fontSize: 6 * fontMultiplier + "mm", fontWeight: "bold" }}>Zahlbar durch</div>
                            <div style={{ fontSize: 8 * fontMultiplier + "mm" }}>
                                <p>Max Muster</p>
                                <p>Beispielstrasse 1</p>
                                <p>8001 Zürich</p>
                            </div>
                        </div>
                        <div style={{ display: "flex", gap: "8mm", marginBottom: "14mm" }}>
                            <div>
                                <div style={{ fontSize: 6 * fontMultiplier + "mm", fontWeight: "bold" }}>Währung</div>
                                <div style={{ fontSize: 8 * fontMultiplier + "mm" }}>CHF</div>
                            </div>
                            <div>
                                <div style={{ fontSize: 6 * fontMultiplier + "mm", fontWeight: "bold" }}>Betrag</div>
                                <div style={{ fontSize: 8 * fontMultiplier + "mm" }}>1 234.50</div>
                            </div>
                        </div>
                        <p style={{ textAlign: "right", fontSize: 6 * fontMultiplier + "mm", fontWeight: "bold" }}>
                            Annahmestelle
                        </p>
                    </div>

                    {/* Right section - Zahlteil */}
                    <div style={{ width: "148mm", padding: "5mm", display: "flex", flexDirection: "column" }}>
                        <div style={{ display: "flex", flexDirection: "row", height: "85mm" }}>
                            {/* QR section */}
                            <div style={{ width: "51mm" }}>
                                <div style={{ fontSize: 11 * fontMultiplier + "mm", fontWeight: "bold", marginBottom: "5mm" }}>
                                    Zahlteil
                                </div>
                                {/* QR Code with static valid data */}
                                <div style={{ marginBottom: "5mm" }}>
                                    <QRCode
                                        value="SPC\n0200\n1\nCH4431999123000889012\nS\nMuster GmbH\nMusterstrasse\n1\n8000\nZuerich\nCH\n\n\n\n\n\n\n1234.50\nCHF\nS\nMax Muster\nBeispielstrasse\n1\n8001\nZuerich\nCH\nQRR\n000000000000000000000000000\nBeispielrechnung\nEPD"
                                        size={130}
                                        errorCorrection="M"
                                    />
                                </div>
                                <div style={{ display: "flex", gap: "6mm" }}>
                                    <div>
                                        <div style={{ fontSize: 8 * fontMultiplier + "mm", fontWeight: "bold" }}>Währung</div>
                                        <div style={{ fontSize: 10 * fontMultiplier + "mm" }}>CHF</div>
                                    </div>
                                    <div>
                                        <div style={{ fontSize: 8 * fontMultiplier + "mm", fontWeight: "bold" }}>Betrag</div>
                                        <div style={{ fontSize: 10 * fontMultiplier + "mm" }}>1 234.50</div>
                                    </div>
                                </div>
                            </div>
                            {/* Details section */}
                            <div style={{ width: "87mm" }}>
                                <div style={{ marginBottom: 11 * fontMultiplier + "mm" }}>
                                    <div style={{ fontSize: 8 * fontMultiplier + "mm", fontWeight: "bold" }}>Konto / Zahlbar an</div>
                                    <div style={{ fontSize: 10 * fontMultiplier + "mm" }}>
                                        <p>{displayIban}</p>
                                        <p>{displayName}</p>
                                        <p>{displayStreet} {displayHouseNumber}</p>
                                        <p>{displayPostalCode} {displayCity}</p>
                                    </div>
                                </div>
                                <div style={{ marginBottom: 11 * fontMultiplier + "mm" }}>
                                    <div style={{ fontSize: 8 * fontMultiplier + "mm", fontWeight: "bold" }}>Referenz</div>
                                    <div style={{ fontSize: 10 * fontMultiplier + "mm" }}>{displayReference}</div>
                                </div>
                                <div style={{ marginBottom: 11 * fontMultiplier + "mm" }}>
                                    <div style={{ fontSize: 8 * fontMultiplier + "mm", fontWeight: "bold" }}>Zahlbar durch</div>
                                    <div style={{ fontSize: 10 * fontMultiplier + "mm" }}>
                                        <p>Max Muster</p>
                                        <p>Beispielstrasse 1</p>
                                        <p>8001 Zürich</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};